import axios from 'axios';

export const getInvoiceCreateNext = async (id: number) => {
  const response = await axios.get(
    `/system/contracts/${id}/invoice/create/next`
  );

  return response.data;
};
